module.exports = {
    untitledSequenceName: 'Untitled Sequence'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js